export default function Products() {
  const rims = [
    {
      name: 'Chrome Sport Wheels',
      image: 'https://public.readdy.ai/ai/img_res/e257b43b06ffec95ba30919a9aa0088f.jpg'
    },
    {
      name: 'Black Matte Finish',
      image: 'https://readdy.ai/api/search-image?query=Premium%20black%20matte%20finish%20alloy%20wheel%20rim%20close-up%20product%20shot%20on%20clean%20white%20background%2C%20brand%20new%20matte%20black%20wheel%20with%20modern%20spoke%20design%2C%20professional%20automotive%20product%20photography%2C%20studio%20lighting%2C%20high%20resolution%2C%20commercial%20quality%2C%20wheel%20positioned%20at%20slight%20angle%20showing%20spoke%20pattern%20and%20depth&width=400&height=400&seq=rim-002&orientation=squarish'
    },
    {
      name: 'Gunmetal Gray',
      image: 'https://readdy.ai/api/search-image?query=Premium%20gunmetal%20gray%20alloy%20wheel%20rim%20close-up%20product%20shot%20on%20clean%20white%20background%2C%20brand%20new%20dark%20gray%20wheel%20with%20modern%20spoke%20design%2C%20professional%20automotive%20product%20photography%2C%20studio%20lighting%2C%20high%20resolution%2C%20commercial%20quality%2C%20wheel%20positioned%20at%20slight%20angle%20showing%20spoke%20pattern%20and%20depth&width=400&height=400&seq=rim-003&orientation=squarish'
    },
    {
      name: 'Machined Face',
      image: 'https://readdy.ai/api/search-image?query=Premium%20machined%20face%20alloy%20wheel%20rim%20close-up%20product%20shot%20on%20clean%20white%20background%2C%20brand%20new%20polished%20machined%20wheel%20with%20modern%20spoke%20design%2C%20professional%20automotive%20product%20photography%2C%20studio%20lighting%2C%20high%20resolution%2C%20commercial%20quality%2C%20wheel%20positioned%20at%20slight%20angle%20showing%20spoke%20pattern%20and%20depth&width=400&height=400&seq=rim-004&orientation=squarish'
    },
    {
      name: 'Bronze Finish',
      image: 'https://readdy.ai/api/search-image?query=Premium%20bronze%20finish%20alloy%20wheel%20rim%20close-up%20product%20shot%20on%20clean%20white%20background%2C%20brand%20new%20bronze%20colored%20wheel%20with%20modern%20spoke%20design%2C%20professional%20automotive%20product%20photography%2C%20studio%20lighting%2C%20high%20resolution%2C%20commercial%20quality%2C%20wheel%20positioned%20at%20slight%20angle%20showing%20spoke%20pattern%20and%20depth&width=400&height=400&seq=rim-005&orientation=squarish'
    },
    {
      name: 'Gloss Black',
      image: 'https://readdy.ai/api/search-image?query=Premium%20gloss%20black%20alloy%20wheel%20rim%20close-up%20product%20shot%20on%20clean%20white%20background%2C%20brand%20new%20shiny%20black%20wheel%20with%20modern%20spoke%20design%2C%20professional%20automotive%20product%20photography%2C%20studio%20lighting%2C%20high%20resolution%2C%20commercial%20quality%2C%20wheel%20positioned%20at%20slight%20angle%20showing%20spoke%20pattern%20and%20depth&width=400&height=400&seq=rim-006&orientation=squarish'
    }
  ];

  return (
    <section id="products" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Rims Section */}
        <div data-product-shop>
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-zinc-900 mb-4">
              Premium Rims & Wheels
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Upgrade your vehicle's look with our extensive selection of high-quality rims and wheels at Seneca Tire Shop
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {rims.map((rim, index) => (
              <div 
                key={index}
                className="bg-white border-2 border-gray-200 rounded-xl overflow-hidden hover:shadow-xl transition-shadow cursor-pointer"
                data-product-shop
              >
                <div className="aspect-square bg-gray-50 overflow-hidden">
                  <img 
                    src={rim.image}
                    alt={rim.name}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-zinc-900 mb-4">{rim.name}</h3>
                  <button className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap w-full">
                    Contact for Pricing
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <p className="text-lg text-gray-600 mb-6">
              Looking for a specific rim style or size? We can special order to meet your needs!
            </p>
            <a 
              href="#contact" 
              className="inline-block bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Get a Quote
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
